// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.custom-brand{
    margin-top: 100px;
    border: 1px solid gray;
    position: relative;
}
.container{
    padding: 12px;
}
.custom-container{
    padding-left: 8%;
    padding-right: 8%;
    width: 100%;

}
.content-container{
    display: flex;
    width: 100%;
    height: 100%;
    align-items: center;
    justify-content: center;
    border: 1px solid gray;
    font-size: 43px;
    color: gray;
    font-weight: 600;
}
.prof-text{
    font-size: 20px;
    color: gray;
    font-weight: 600;
}
.prof-text span{
    font-size: 12px;
}
.text-content{
    color: gray !important;
    font-weight: 600;
    font-size: 31px !important;
}
.prof-image{
    width: 166px;
    height: 166px;
    border-radius: 50%;
}
.butoon-add{
    border: none;
    background: #8600ff;
    color: white;
    padding: 6px 27px;
    border-radius: 3px;
    font-size: 15px;
    font-weight: 600;
    letter-spacing: 1.3px;
}
.main-tab-container{
    min-height: 35vh;
    border: 1px solid gray;
    overflow-x: hidden;
    overflow-y: scroll;
    max-height: 40vh;
}
.main-tab-container p:first-child{
    color: #969494;
    font-size: 27px;
    font-weight: 600;
}
.main-tab-container p{
    color: #000000;
    font-size: 16px;
}
ul li{
    display: block;
    background-color: red;
    border: 2px solid pink;
}
/* ul li {
    text-align: center;
} */
li img{
    /* width: 20px;
    height: 20px; */
    text-align: left !important;
}
.content-table{
    margin: 4px 20px;
    border: 1px solid gray;

}
.comment-img{
    border-radius: 50%;
}
.cmnt-txt1{
    height: 100%;
    background: #8600ff;
    border-radius: 6px;
    padding: 2px 22px;
    color: white;
}

.cmnt-txt2{
    color: white;
    height: 100%;
    background: #00cbff;
    border-radius: 6px;
    padding: 2px 22px;
}
.leave-comment-btn{
    border: none;
    background: #8600ff;
    padding: 5px 20px;
    border-radius: 4px;
    color: white;
    margin-bottom: 29px;
}
.img-pos{
    display: flex;
    align-items: center;
}
.course-content{
    height: 40px;
    width: 40px;

    object-fit: cover;
}
.icon-img{
    position: absolute;
    bottom: 0;
    right: 0;
    z-index: 1;
}
.my-img{
    display: flex;
    align-items: center;
}
.comment-board{
    position: relative;
    z-index: 2;
}
@media (max-width :768px){
    .content-container{
        font-size: 15px;
    }
    .course-content{
        height: 100%;
        width: 100%;
    }
    .main-tab-container{
        min-height: 50vh;
        max-height: 50vh;
    }
    .text-content{
        font-size: 22px !important;
    }
    .butoon-addcustom-brand border{
        font-size: 10px;
    }
    .icon-img{
        width: 65px;
    }
}`, "",{"version":3,"sources":["webpack://./src/app/afterLogin/custom-brand/custom-brand.component.css"],"names":[],"mappings":"AAAA;IACI,iBAAiB;IACjB,sBAAsB;IACtB,kBAAkB;AACtB;AACA;IACI,aAAa;AACjB;AACA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,WAAW;;AAEf;AACA;IACI,aAAa;IACb,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,uBAAuB;IACvB,sBAAsB;IACtB,eAAe;IACf,WAAW;IACX,gBAAgB;AACpB;AACA;IACI,eAAe;IACf,WAAW;IACX,gBAAgB;AACpB;AACA;IACI,eAAe;AACnB;AACA;IACI,sBAAsB;IACtB,gBAAgB;IAChB,0BAA0B;AAC9B;AACA;IACI,YAAY;IACZ,aAAa;IACb,kBAAkB;AACtB;AACA;IACI,YAAY;IACZ,mBAAmB;IACnB,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,qBAAqB;AACzB;AACA;IACI,gBAAgB;IAChB,sBAAsB;IACtB,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;AACpB;AACA;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;AACpB;AACA;IACI,cAAc;IACd,eAAe;AACnB;AACA;IACI,cAAc;IACd,qBAAqB;IACrB,sBAAsB;AAC1B;AACA;;GAEG;AACH;IACI;mBACe;IACf,2BAA2B;AAC/B;AACA;IACI,gBAAgB;IAChB,sBAAsB;;AAE1B;AACA;IACI,kBAAkB;AACtB;AACA;IACI,YAAY;IACZ,mBAAmB;IACnB,kBAAkB;IAClB,iBAAiB;IACjB,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,mBAAmB;IACnB,kBAAkB;IAClB,iBAAiB;AACrB;AACA;IACI,YAAY;IACZ,mBAAmB;IACnB,iBAAiB;IACjB,kBAAkB;IAClB,YAAY;IACZ,mBAAmB;AACvB;AACA;IACI,aAAa;IACb,mBAAmB;AACvB;AACA;IACI,YAAY;IACZ,WAAW;;IAEX,iBAAiB;AACrB;AACA;IACI,kBAAkB;IAClB,SAAS;IACT,QAAQ;IACR,UAAU;AACd;AACA;IACI,aAAa;IACb,mBAAmB;AACvB;AACA;IACI,kBAAkB;IAClB,UAAU;AACd;AACA;IACI;QACI,eAAe;IACnB;IACA;QACI,YAAY;QACZ,WAAW;IACf;IACA;QACI,gBAAgB;QAChB,gBAAgB;IACpB;IACA;QACI,0BAA0B;IAC9B;IACA;QACI,eAAe;IACnB;IACA;QACI,WAAW;IACf;AACJ","sourcesContent":[".custom-brand{\n    margin-top: 100px;\n    border: 1px solid gray;\n    position: relative;\n}\n.container{\n    padding: 12px;\n}\n.custom-container{\n    padding-left: 8%;\n    padding-right: 8%;\n    width: 100%;\n\n}\n.content-container{\n    display: flex;\n    width: 100%;\n    height: 100%;\n    align-items: center;\n    justify-content: center;\n    border: 1px solid gray;\n    font-size: 43px;\n    color: gray;\n    font-weight: 600;\n}\n.prof-text{\n    font-size: 20px;\n    color: gray;\n    font-weight: 600;\n}\n.prof-text span{\n    font-size: 12px;\n}\n.text-content{\n    color: gray !important;\n    font-weight: 600;\n    font-size: 31px !important;\n}\n.prof-image{\n    width: 166px;\n    height: 166px;\n    border-radius: 50%;\n}\n.butoon-add{\n    border: none;\n    background: #8600ff;\n    color: white;\n    padding: 6px 27px;\n    border-radius: 3px;\n    font-size: 15px;\n    font-weight: 600;\n    letter-spacing: 1.3px;\n}\n.main-tab-container{\n    min-height: 35vh;\n    border: 1px solid gray;\n    overflow-x: hidden;\n    overflow-y: scroll;\n    max-height: 40vh;\n}\n.main-tab-container p:first-child{\n    color: #969494;\n    font-size: 27px;\n    font-weight: 600;\n}\n.main-tab-container p{\n    color: #000000;\n    font-size: 16px;\n}\nul li{\n    display: block;\n    background-color: red;\n    border: 2px solid pink;\n}\n/* ul li {\n    text-align: center;\n} */\nli img{\n    /* width: 20px;\n    height: 20px; */\n    text-align: left !important;\n}\n.content-table{\n    margin: 4px 20px;\n    border: 1px solid gray;\n\n}\n.comment-img{\n    border-radius: 50%;\n}\n.cmnt-txt1{\n    height: 100%;\n    background: #8600ff;\n    border-radius: 6px;\n    padding: 2px 22px;\n    color: white;\n}\n\n.cmnt-txt2{\n    color: white;\n    height: 100%;\n    background: #00cbff;\n    border-radius: 6px;\n    padding: 2px 22px;\n}\n.leave-comment-btn{\n    border: none;\n    background: #8600ff;\n    padding: 5px 20px;\n    border-radius: 4px;\n    color: white;\n    margin-bottom: 29px;\n}\n.img-pos{\n    display: flex;\n    align-items: center;\n}\n.course-content{\n    height: 40px;\n    width: 40px;\n\n    object-fit: cover;\n}\n.icon-img{\n    position: absolute;\n    bottom: 0;\n    right: 0;\n    z-index: 1;\n}\n.my-img{\n    display: flex;\n    align-items: center;\n}\n.comment-board{\n    position: relative;\n    z-index: 2;\n}\n@media (max-width :768px){\n    .content-container{\n        font-size: 15px;\n    }\n    .course-content{\n        height: 100%;\n        width: 100%;\n    }\n    .main-tab-container{\n        min-height: 50vh;\n        max-height: 50vh;\n    }\n    .text-content{\n        font-size: 22px !important;\n    }\n    .butoon-addcustom-brand border{\n        font-size: 10px;\n    }\n    .icon-img{\n        width: 65px;\n    }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
